// React
import { ReactElement } from 'react';
// Design System
import { Font } from '@utmb/design-system/text/font';
// Types
import { CheckboxProps } from '@utmb/types/form';
// Styles
import styles from './checkbox.module.scss';

export const Checkbox = (props: CheckboxProps): ReactElement => {
    const { id, name, value, checked, onChange, onBlur, label, className = undefined, readOnly = false, onClick = undefined } = props;

    return (
        <div className={styles.container}>
            <div className={styles.input_container}>
                <input
                    id={id}
                    type="checkbox"
                    name={name}
                    checked={checked}
                    value={value}
                    className={className}
                    onChange={onChange}
                    onBlur={onBlur}
                    disabled={readOnly}
                    onClick={onClick}
                />
                <div className={styles.input_element}></div>
            </div>

            {label && (
                <Font.FuturaBook as="span" mobile="18" desktop="22" className={styles.label}>
                    <label htmlFor={id} dangerouslySetInnerHTML={{ __html: label }} onClick={onClick}></label>
                </Font.FuturaBook>
            )}
        </div>
    );
};
